import React from "react";
import "./NgoDashboard.css";
import { Link } from "react-router-dom";

function NgoDashboard() {
  return (
    
        <div
  className="ngo-page"
  style={{
    backgroundImage: "url('/images/food-waste.webp')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>

      {/* HEADER */}
      <header className="header">
        <div className="header-container">
          <h1 className="logo">SaveBite</h1>

          <nav className="navigation">
            
            <Link to="/ngo/collectedfood">Collected Food</Link>
            <Link to="/ngo/collectfood">Available Surplus</Link>
            <Link to="/ngo/account">My Account</Link>
          </nav>
        </div>
      </header>
      


      {/* HERO WITH IMAGE */}
      <section className="hero-section">
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <h2>Welcome to SaveBite 💚</h2>
          <p>
            Together, we reduce food waste and bring hope to communities in need.
            Your role as an NGO helps transform surplus food into meaningful impact.
          </p>
        </div>
      </section>

      {/* INFO SECTION */}
      <section className="info-section">
        <div className="info-card">
          <h3>🤝 Your Mission</h3>
          <p>
            Discover surplus food shared by hotels and ensure it reaches people
            who truly need it.
          </p>
        </div>

        <div className="info-card">
          <h3>📦 Donation Management</h3>
          <p>
            Track accepted donations, manage collections, and maintain records
            with ease.
          </p>
        </div>

        <div className="info-card">
          <h3>🎉 Events & Drives</h3>
          <p>
            Collaborate with hotels on food drives, celebrations, and community
            outreach programs.
          </p>
        </div>
      </section>

      

    </div>
  );
}

export default NgoDashboard;
